const STARS = [
  { top: "-18%", left: "-4%", size: 18, color: "#FF7043", delay: "0s" },
  { top: "-30%", left: "46%", size: 12, color: "#7C3AED", delay: "0.6s" },
  { top: "-10%", left: "98%", size: 20, color: "#2563EB", delay: "1.1s" },
  { top: "78%", left: "26%", size: 11, color: "#FF7043", delay: "1.6s" },
  { top: "70%", left: "84%", size: 14, color: "#7C3AED", delay: "0.9s" },
];

const Star = ({ size, color }) => (
  <svg style={{ width: `max(${Math.round(size * 0.75)}px, ${size / 36}em)`, height: `max(${Math.round(size * 0.75)}px, ${size / 36}em)` }} viewBox="0 0 24 24" fill={color} aria-hidden>
    <path d="M12 0c.6 6.2 5.8 11.4 12 12-6.2.6-11.4 5.8-12 12-.6-6.2-5.8-11.4-12-12C6.2 11.4 11.4 6.2 12 0z" />
  </svg>
);

export const Sparkle = ({ children, className = "" }) => (
  <span className={`relative inline-block ${className}`} data-testid="sparkle-text">
    {STARS.map((s, i) => (
      <span key={i} className="sparkle-star pointer-events-none absolute" style={{ top: s.top, left: s.left, animationDelay: s.delay }}>
        <Star size={s.size} color={s.color} />
      </span>
    ))}
    <span className="relative">{children}</span>
  </span>
);

export const SparkleText = ({ text, phrase = /(human touch)/i }) =>
  String(text).split(phrase).map((part, i) => (i % 2 ? <Sparkle key={i}>{part}</Sparkle> : part));
